<template>
  <!-- Dialog Add Promotional Activity -->
  <ib-dialog
    id="dialog-story-mode-add-distribution"
    empty-header
    :visible="dialogAddDistributionVisible"
    :fullscreen="true"
    @open="openDialog"
    @close="closeDialog"
    @closed="closedDialog"
  >
    <!-- Mobile title -->
    <template #title>
      <ib-dialog-container class="d-md-none">
        <h2>
          {{ $tc('addSalesChannel') }}
        </h2>
      </ib-dialog-container>
    </template>
    <!-- /Mobile title -->

    <!-- Content Wrapper -->
    <ib-dialog-container class="content-wrapper px-1" max-width="1920px">
      <!-- Header -->
      <add-dialog-header>
        <template #left>
          <!-- Title -->
          <h2 class="m-0">
            {{ $tc('addSalesChannel') }}
          </h2>
          <!-- /Title -->
        </template>
      </add-dialog-header>
      <!-- /Header -->

      <!-- Info Guide -->
      <info-guide-add-dialog
        class="mb-3 d-block d-xl-none"
        :visible="guideVisible"
        :title="$t('pages.businessGuide.distribution.addDialog.guide.title')"
        :text="$t('pages.businessGuide.distribution.addDialog.guide.text')"
        @click="onToggleDialogGuide"
      />
      <!-- Info Guide -->

      <!-- Ai Buddy -->
      <ai-buddy
        v-if="$breakpoint.lgAndDown"
        type="distribution"
        class="ai-buddy-margin-bottom d-block d-xl-none"
        @suggestion="setSuggestion"
        @click="guideVisible = false"
      />
      <!-- Ai Buddy -->

      <!-- Inner Wrapper -->
      <div class="inner-wrapper">
        <div class="grid-wrapper">
          <el-row :gutter="20">

            <!-- Left Side -->
            <el-col :md="12" :xl="7">

              <!-- Avatar setter -->
              <!--              <avatar-setter v-if="cropping" @click="cropImage" />-->
              <!-- /Avatar setter -->

              <!-- Form Wrapper -->
              <div class="product-form-wrapper">
                <!-- Avatar And Uploader -->
                <ib-avatar-uploader
                  ref="avatarUploader"
                  :image="form.image"
                  :default-image="require('@/assets/img/icons/story-mode/delivery-truck.svg')"
                  @cropping="cropping = true"
                  @change="form.croppedImage = $event"
                  @crop="cropImage"
                  @delete="deleteImage"
                />
                <!-- /Avatar And Uploader -->

                <!-- Form Inner -->
                <div class="product-form-inner">

                  <!-- Form -->
                  <el-form ref="form" :model="form" @submit.native.prevent>
                    <!-- Product Or Service Name -->
                    <div class="d-flex align-items-center">
                      <ib-input
                        v-model="form.name"
                        class="flex-grow-1"
                        :label="$t('pages.businessGuide.distribution.addDialog.fields.salesChannelName')"
                        :maxlength="50"
                      />
                      <ai-buddy-button-rounded
                        class="ai-buddy ml-2"
                        emit-event-buss-events
                        animation-key="roundedButtonAddModal"
                      />
                    </div>
                    <!-- /Product Or Service Name -->

                    <!-- Description -->
                    <el-form-item>
                      <el-input
                        v-model="form.description"
                        type="textarea"
                        maxlength="500"
                        :rows="4"
                        class=""
                        :placeholder="$t('pages.businessGuide.distribution.addDialog.fields.shortDescription')"
                        resize="none"
                      />
                    </el-form-item>
                    <!-- /Description -->

                  </el-form>
                  <!-- /Form -->

                </div>
                <!-- /Form Inner -->

              </div>
              <!-- /Form Wrapper -->

              <!-- Dialog Bottom -->
              <div class="my-4 my-md-0">
                <!-- Divider -->
                <ib-divider block class="my-4" />
                <!-- /Divider -->

                <el-row :gutter="10" class="d-flex">
                  <el-col :span="12">
                    <!-- Close -->
                    <ib-button class="w-100" variant="white" size="lg" font-family="regular" @click="closeDialog">
                      {{ $t('close') }}
                    </ib-button>
                    <!-- /Close -->
                  </el-col>

                  <el-col :span="12">
                    <ib-button
                      class="w-100 text-uppercase"
                      size="lg"
                      :disabled="form.name === ''"
                      :loading="loading"
                      @click="saveDistribution"
                    >
                      {{ form.id === 0 ? $t('add') : $t('save') }}
                    </ib-button>
                  </el-col>
                </el-row>
              </div>
              <!-- /Dialog Bottom -->

            </el-col>
            <!-- /Left Side -->

            <!-- Center -->
            <el-col :md="12" :xl="7">
              <template v-if="!getDistributions.length">
                <div class="d-flex flex-column justify-content-center align-items-center mt-5">
                  <img class="add-dialog-folder-icon" src="@/assets/img/icons/add-dialog-folder.svg" alt="">
                  <p class="add-dialog-folder-text font-outfit-regular">
                    {{ $t('createdItemsWillAppearHere') }}
                  </p>
                </div>
              </template>

              <!-- Products Added -->
              <div ref="cardHolder" class="products-added">

                <ib-draggable
                  :list="getDistributions"
                  draggable=".product"
                  @change="onChangeDistributionOrder"
                  @start="onStartDistributionOrder"
                >
                  <!-- Products Added List -->
                  <div
                    v-for="distribution in getDistributions"
                    :key="distribution.id"
                    class="product cursor-move"
                    @click="onEditDistribution(distribution)"
                  >

                    <!-- Product Image & Name -->
                    <div class="product-left">

                      <div>
                        <!-- Default Image -->
                        <div v-if="distribution.image === null" class="img-wrapper">
                          <svg height="512" viewBox="0 0 96 96" width="512" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#3E474F" opacity=".1" d="M29 64c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm0 13a4 4 0 110-8 4 4 0 010 8zm60.452-28.612L76.875 34.332A10 10 0 0069.423 31H54V20c0-3.309-2.691-6-6-6H10c-3.309 0-6 2.691-6 6v47c0 3.309 2.691 6 6 6h7c0-6.627 5.373-12 12-12s12 5.373 12 12h18c0-6.627 5.373-12 12-12s12 5.373 12 12h3a6 6 0 006-6V55.057a9.99 9.99 0 00-2.548-6.669zm-8.537 5.014A.998.998 0 0180 54H60a1 1 0 01-1-1V41a1 1 0 011-1h8.12c.839 0 1.645.354 2.212.973l10.405 11.352a.997.997 0 01.178 1.077zM71 64c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm0 13a4 4 0 110-8 4 4 0 010 8z"/></svg>
                        </div>
                        <!-- /Default Image -->

                        <!-- Product Image -->
                        <div
                          v-else
                          class="img-wrapper img-wrapper-filled"
                          :style="cardImageBySize(distribution.image, 'small')"
                        />
                        <!-- /Product Image -->
                      </div>

                      <!-- Product Name -->
                      <p class="product-name">
                        {{ distribution.name }}
                      </p>
                    <!-- /Product Name -->

                    </div>
                    <!-- /Product Image & Name -->

                    <!-- Actions Dropdown -->
                    <actions-dropdown
                      ref="itemDropdownWrapper"
                      :entity="distribution"
                      :delete-disabled="form.id === distribution.id"
                      :edit-disabled="form.id === distribution.id"
                      @edit="onEditDistribution"
                      @copy="onCopyDistribution"
                      @delete="deleteStoryModeDistribution($event.id)"
                    />
                  <!-- /Actions Dropdown -->

                  </div>
                </ib-draggable>
                <!-- /Products Added List -->
                <erase-icon-button
                  v-if="removeButtonVisible"
                  confirm
                  :loading="removeLoadingExamples"
                  @confirm="deleteExamples"
                />
              </div>
              <!-- /Products Added -->

            </el-col>
            <!-- /Center -->

            <!-- Right Side -->
            <el-col :xl="10">
              <!-- Info Guide -->
              <info-guide-add-dialog
                class="mb-3 d-none d-xl-block"
                :visible="guideVisible"
                :title="$t('pages.businessGuide.distribution.addDialog.guide.title')"
                :text="$t('pages.businessGuide.distribution.addDialog.guide.text')"
                @click="onToggleDialogGuide"
              />
              <!-- Info Guide -->

              <!-- Ai Buddy -->
              <div class="relative">
                <ai-buddy
                  v-if="$breakpoint.lgAndUp"
                  type="distribution"
                  class="ai-buddy-margin-bottom d-none d-xl-block"
                  @suggestion="setSuggestion"
                  @click="handwritingSet('addSalesSuggestion'); guideVisible = false"
                />
                <!-- Ai Buddy -->
                <div v-if="getHandwritingVisible('addSalesSuggestion')" class="d-none d-xl-block">
                  <AddDialogAiHandwriting />
                </div>
              </div>
              <!-- Ai Buddy -->
            </el-col>
            <!-- /Right Side -->
          </el-row>
        </div>
      </div>
      <!-- /Inner Wrapper -->
    </ib-dialog-container>
    <!-- /Content Wrapper -->

  </ib-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ActionsDropdown from '@/views/Home/StoryMode/Components/ActionsDropdown'
import AddDialogHeader from '@/components/_v2/Common/AddDialogHeader'
import AiBuddyButtonRounded from '@/views/Home/StoryMode/Components/AiBuddyButtonRounded.vue'
// import AvatarSetter from '@/views/Home/StoryMode/Components/AvatarSetter'
import AddDialogAiHandwriting from '@/views/Home/Components/AddDialogAiHandwriting.vue'
import AiBuddy from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddy.vue'
import EraseIconButton from '@/components/_v2/EraseIconButton'
import IbAvatarUploader from '@/components/_v2/IbAvatarUploader'
import InfoGuideAddDialog from '@/views/Home/StoryMode/Components/Guide/InfoGuideAddDialog.vue'
import MixinCloseMenu from '@/mixins/closeDropdownMenuOnScroll'
import MixinDeleteIdeaExamples from '@/mixins/deleteIdeaExamples'
import MixinDialog from '@/mixins/dialog'
import MixinGuide from '@/mixins/guide'
import MixinHandwriting from '@/mixins/handwriting'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import { getImageBySize } from '@/helpers/imageSizeHelper'

export default {
  name: 'DialogAddDistribution',

  components: {
    AddDialogAiHandwriting,
    AiBuddy,
    AiBuddyButtonRounded,
    InfoGuideAddDialog,
    EraseIconButton,
    ActionsDropdown,
    AddDialogHeader,
    // AvatarSetter,
    IbAvatarUploader
  },

  mixins: [
    MixinCloseMenu,
    MixinDialog,
    MixinGuide,
    MixinIdeaRoles,
    MixinDeleteIdeaExamples,
    MixinHandwriting
  ],

  props: {
    dialogAddDistributionVisible: {
      type: Boolean,
      default: false
    },
    distributionAction: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      loading: false,
      removeLoadingExamples: false,
      cropping: false,
      guideVisible: false,
      form: {
        id: 0,
        image: null,
        uploadedImage: null,
        croppedImage: null,
        ideaId: this.$store.state.idea.id,
        name: '',
        description: ''
      }
    }
  },

  computed: {
    ...mapGetters('idea', [
      'getDistributions',
      'getHasItemsFromTemplate'
    ]),

    isDialogOpen () {
      return this.dialogAddDistributionVisible
    },

    removeButtonVisible () {
      return this.canEdit && this.getHasItemsFromTemplate('getDistributions')
    }
  },

  watch: {
    'form.name' () {
      this.form.name = this.form.name.replace(/^\s+/g, '')
    }
  },

  methods: {
    ...mapActions('idea', [
      'deleteStoryModeDistribution',
      'updateOrderNumber'
    ]),

    setSuggestion (suggestion) {
      this.form.name = suggestion.name
      this.form.description = suggestion.description
    },

    onStartDistributionOrder () {
      this.$refs.itemDropdownWrapper.forEach(dropdown => {
        dropdown.$refs.itemDropdown.visible = false
      })
    },

    onChangeDistributionOrder (data) {
      this.updateOrderNumber({
        type: 'distribution',
        data,
        oldOrderData: this.getDistributions,
        mutation: 'setDistribution'
      })
    },

    closeDialog () {
      this.$emit('close-dialog-add-distribution')
    },

    closedDialog () {
      this.resetForm()
      this.guideVisible = false
    },

    openDialog () {
      this.openGuideDialog('addDistributionGuide')
      if (this.distributionAction) {
        this.form.id = this.distributionAction.id
        this.form.ideaId = this.$store.state.idea.id
        this.form.image = this.distributionAction.image
        this.form.name = this.distributionAction.name
        this.form.description = this.distributionAction.description
      }
    },

    onToggleDialogGuide () {
      this.guideVisible = !this.guideVisible
    },

    resetForm () {
      this.form = {
        id: 0,
        ideaId: this.$store.state.idea.id,
        image: null,
        uploadedImage: null,
        croppedImage: null,
        name: '',
        description: ''
      }
      this.cropping = false
      this.$refs.avatarUploader.reset()
    },

    resetGuide () {
      if (this.$store.getters['idea/getDistributions'].length === 0) {
        this.guideVisible = false
      }
    },

    saveDistribution () {
      this.loading = true
      if (this.cropping) {
        this.cropImage()
      }
      if (this.form.id === 0) {
        this.addDistribution()
      } else {
        this.updateDistribution()
      }
    },

    addDistribution () {
      delete this.form.uploadedImage
      this.$http.post('story-mode/concept/distribution/distributions', this.form)
        .then((response) => {
          if (response.status === 201) {
            this.resetGuide()
            this.$store.commit('idea/addDistribution', response.data.payload.distribution)
            this.resetForm()
          }
        }).finally(() => {
          this.loading = false
        })
    },

    updateDistribution () {
      this.$http.put(`story-mode/concept/distribution/distributions/${this.form.id}`, this.form)
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit('idea/updateDistribution', response.data.payload.distribution)
            this.resetForm()
          }
        }).finally(() => {
          this.loading = false
        })
    },

    onEditDistribution (distribution) {
      this.resetForm()
      this.form = Object.assign({}, distribution)
      this.form.ideaId = this.$store.state.idea.id
      this.$set(this.form, 'uploadedImage', null)
      this.$set(this.form, 'croppedImage', null)
      this.scrollToTop()
    },

    onCopyDistribution (distribution) {
      this.resetForm()
      this.form = Object.assign({}, distribution)
      this.form.id = 0
      this.form.ideaId = this.$store.state.idea.id
      this.$set(this.form, 'uploadedImage', null)
      this.$set(this.form, 'croppedImage', null)
      this.scrollToTop()
    },

    deleteImage () {
      this.form.image = null
      this.form.uploadedImage = null
      this.form.croppedImage = null
    },

    cropImage () {
      this.cropping = false
      const image = this.$refs.avatarUploader.cropImage()
      if (image) {
        this.form.croppedImage = image.croppedImage
        this.form.uploadedImage = image.uploadedImage

        return
      }
      this.deleteImage()
    },

    cardImageBySize (image, size) {
      return image ? 'background-image: url(' + getImageBySize(image.sizes, size) + ')' : ''
    },

    async deleteExamples () {
      try {
        this.removeLoadingExamples = true
        const response = await this.deleteIdeaExamples('distributions')
        const { type, ids } = response
        this.deleteFromState({ type, ids })
        this.resetForm()
        this.removeLoadingExamples = false
      } catch (error) {
        this.removeLoadingExamples = false
      }
    }
  }
}
</script>

<style scoped lang="scss">

.add-dialog-folder-icon {
  width: 80px;
  @include media-breakpoint-up($xxl) {
    width: 100px;
  }
}

.add-dialog-folder-text {
  font-size: 14px;
  @include media-breakpoint-up($xxl) {
    font-size: 16px;
  }
}

</style>
